<template>
  <div class="vue-dialog">
    <div class="dialog-content">
      <div class="dialog-c-title">
        Добавить в лист ожидания
      </div>
      <div class="dialog-c-text">
        <div v-if="!requestSend">
          {{ product.name }}
          <form >
            <input
                class="def-form-input"
                type="text"
                placeholder="Ваше имя"
                v-model="params.fio"
            />
            <input
                class="def-form-input"
                type="text"
                placeholder="Номер телефона"
                v-model="params.phone"
            />
            <input
                class="def-form-input"
                type="text"
                placeholder="Email, куда выслать уведомление"
                v-model="params.email"
            />
            <p>&nbsp;</p>
            <div class=" def-form-checkbox">
              <div class="radio-custom" @click="agreeWithPrivacy=true"
                   :class="{'active' : agreeWithPrivacy}"></div>
              <label style="line-height: 1.5">
                Согласие на обработку персональных данных в соответствии с
                <a href="/privacy-policy"> политикой конфиденциальности </a>
              </label>
            </div>
          </form>
        </div>
        <div class="bootstrap" v-else>
          <p>&nbsp;</p>
          <h4 class="text-center"> Ваш запрос успешно отправлен. Как только товар появится на складе, мы сразу сообщим Вам об этом. </h4>
          <p class="text-center"><a href="/catalog/top">Перейти в общий каталог</a></p>
          <p>&nbsp;</p>
        </div>
      </div>
      <button v-if="!requestSend" type="button" @click="send()" class="btn-gray">
        Отправить запрос
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddToWaitListDialog',
  props: ['product'],
  data () {
    return {
      agreeWithPrivacy: true,
      requestSend: false,
      params: {
        fio: null,
        phone: null,
        email: null
      }
    }
  },
  methods: {
    send() {
      let error = []
      if (!this.params.fio) error.push('Не указано имя');
      if (!this.params.email) error.push('Не указан email');
      if (!this.agreeWithPrivacy) error.push('Необходимо указать что Вы согласны с правилами обработкии персональных данных')

      if(this.params.email && !(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.params.email))){
         error.push('Email указан неверно');
      }

      if (error.length > 0) {
        this.$modal.show('dialog', {
          title: 'Ошибки в процессе заполнения',
          text: '<ul class="order-errors-list"><li>' + error.join('</li><li>') + '</li></ul>',
          buttons: [
            {
              title: 'Закрыть'
            }
          ]
        })
        return
      }
      this.params.product_id = this.product.id
      this.$http.post('/customer/add-to-wait-list', this.params).then(response => {
        response
        this.requestSend = true
      });

    }
  }
}
</script>

<style scoped>
  .btn-gray {
    width: 100%;
  }
</style>